import React from 'react';
import PropTypes from 'prop-types';
import getText from 'context/language/getText';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import { BodyLarge, BodyRegular } from 'components/common_v2/typography';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { useStyles } from './styled';

export const NoPaymentMethod = ({ user }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    history.push(urlConstructor(urlMap.MY_INFO, { id: user.id }));
  };

  return (
    <div>
      <BodyLarge className={classes.warning}>
        {getText('banners.noPaymentMethod.title')}
      </BodyLarge>
      <BodyRegular className={classes.warning}>
        {getText('banners.noPaymentMethod.notice')}
        <Button variant="text" style={{ padding: 0 }} onClick={handleClick}>
          {getText('banners.noPaymentMethod.action')}
        </Button>
        {getText('banners.noPaymentMethod.postJobs')}
      </BodyRegular>
    </div>
  );
};

NoPaymentMethod.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired
};
